if (!customElements.get('tpt-event-filter')) {
	customElements.define(
		'tpt-event-filter',
		class TptEventFilter extends HTMLElement {
			constructor() {
				super();

				this.filterItems = this.querySelectorAll('tpt-event-filter-item');
				this.buttonToggle = this.querySelector('tpt-event-filter-toggle');
				this.events = document.querySelectorAll('[data-event-type]');

				this.buttonToggle.addEventListener('click', this.showFilterDropdown.bind(this));

				this.filterItems.forEach((filter) => {
					filter.addEventListener('click', this.filterEvent.bind(this));
				});
			}

			showFilterDropdown() {
				this.classList.toggle('active');
			}

			closeDropdown() {
				this.classList.remove('active');
			}

			hiddenAllEvent() {
				this.events.forEach((item) => {
					item.classList.add('hidden');
				});
			}

			showAllEvent() {
				this.events.forEach((item) => {
					item.classList.remove('hidden');
				});
			}

			showEventByType(typeValue) {
				const events = document.querySelectorAll(`[data-event-type="${typeValue}"]`);

				events.forEach((item) => {
					item.classList.remove('hidden');
				});
			}

			updateToggleButton(selectedValue) {
				this.buttonToggle.querySelector('.event-fitler__value').innerHTML = selectedValue;
			}

			filterEvent(event) {
				const filter = event.currentTarget;
				const filtervalue = filter.getAttribute('data-value');
				const filterLabel = filter.getAttribute('data-label');

				this.filterItems.forEach((item) => {
					item.classList.remove('active');
				});

				filter.classList.add('active');

				if (filtervalue) {
					this.hiddenAllEvent();
					this.showEventByType(filtervalue);
				} else {
					this.showAllEvent();
				}

				this.updateToggleButton(filterLabel);

				this.closeDropdown();
			}
		}
	);
}
